'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeProvider = require('@spp/theme-provider');

var _ExternalArticles = require('./ExternalArticles');

var _ExternalArticles2 = _interopRequireDefault(_ExternalArticles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeProvider.themer)('@vg/external-articles')(_ExternalArticles2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/external-articles/lib/cjs/index.js
 ** module id = 722
 ** module chunks = 1
 **/